// Remarcacao (Bug 7976): totalBpe/totalConvenience/... descrevem o BP-e NOVO inteiro - numa
// remarcacao isso e o preco da passagem, nao o desembolso. O abatimento do bilhete anterior vem do
// backend em order.rebookingCredit (nulo/0 em pedido sem remarcacao) - o Hub NAO consegue derivar
// isso de order.value/AmountPaid (o legado cobra a diferenca por fora; o Hub nunca registra o
// desembolso real ali), entao o credito e resolvido a partir do bilhete original e exposto pronto.
export function computeOrderTotal(order) {
	const composedTotal =
		(order.totalBpe || 0) +
		(order.totalConvenience || 0) +
		(order.totalJuros || 0) +
		(order.totalToll || 0) +
		(order.totalFee || 0) +
		(order.totalInsurance || 0) +
		(order.totalOther || 0) -
		(order.totalDiscount || 0)

	const rebookingCredit = order.rebookingCredit || 0
	const hasRebookingCredit = rebookingCredit > 0

	// Bug 8002: compra/remarcação em pontos. order.points = pontos do pedido; o crédito do bilhete
	// anterior pago com pontos vem em order.rebookingCreditPoints (a parte em reais segue em
	// rebookingCredit, 0 numa troca só em pontos).
	const points = order.points || 0
	const rebookingCreditPoints = order.rebookingCreditPoints || 0
	const hasRebookingCreditPoints = rebookingCreditPoints > 0

	// Soma de componentes em ponto flutuante pode deixar -1e-14 e virar "Reembolso R$ 0,00".
	const total = Math.round((hasRebookingCredit ? composedTotal - rebookingCredit : composedTotal) * 100) / 100 || 0

	return {
		total,
		rebookingCredit,
		hasRebookingCredit,
		points,
		rebookingCreditPoints,
		hasRebookingCreditPoints,
		totalPoints: points - rebookingCreditPoints,
		usesPoints: points > 0 || hasRebookingCreditPoints,
	}
}

// Bug 8002: o que as remarcações deste pedido (original) movimentaram — vem do Hub em
// order.rebookingOutcome ({ refundedValue, refundedPoints, chargedValue, chargedPoints }). Devolve as
// linhas a exibir no modal, na ordem: estornos e depois cobranças; vazio quando não houve remarcação.
export function rebookingOutcomeRows(order) {
	const outcome = order && order.rebookingOutcome
	if (!outcome) return []

	const rows = []
	if (outcome.refundedValue > 0)
		rows.push({ label: 'Estornado na remarcação', value: outcome.refundedValue, kind: 'money' })
	if (outcome.refundedPoints > 0)
		rows.push({ label: 'Pontos devolvidos na remarcação', value: outcome.refundedPoints, kind: 'points' })
	if (outcome.chargedValue > 0)
		rows.push({ label: 'Cobrado na remarcação', value: outcome.chargedValue, kind: 'money' })
	if (outcome.chargedPoints > 0)
		rows.push({ label: 'Pontos cobrados na remarcação', value: outcome.chargedPoints, kind: 'points' })
	return rows
}

// Linhas do total do pedido, com os valores sem sinal ({ label, points, money }; null = não exibe a moeda).
// Reais e pontos no MESMO sentido: uma linha só, "Reembolso" quando a remarcação só devolve. Em sentidos
// OPOSTOS (bilhete pago com pontos remarcado no cartão: cobra reais e devolve pontos), um rótulo por moeda -
// um "Reembolso" único esconderia o que foi cobrado.
export function totalRows({ total, totalPoints, usesPoints }) {
	const oppositeSigns = (total > 0 && totalPoints < 0) || (total < 0 && totalPoints > 0)
	if (oppositeSigns) {
		return [
			{ label: total > 0 ? 'Total a pagar' : 'Valor devolvido', points: null, money: Math.abs(total) },
			{ label: totalPoints > 0 ? 'Pontos a pagar' : 'Pontos devolvidos', points: Math.abs(totalPoints), money: null },
		]
	}

	const isRefund = total <= 0 && totalPoints <= 0 && (total < 0 || totalPoints < 0)
	return [
		{
			label: isRefund ? 'Reembolso' : 'Total',
			points: usesPoints ? Math.abs(totalPoints) : null,
			money: !usesPoints || total !== 0 ? Math.abs(total) : null,
		},
	]
}
